import React, { useEffect, useState } from 'react';
import SmartSelectInput from '@components/form-elements/smartSelectInput';
import WorkLogForm from './WorkLogForm';
import WorkLogList from './WorkLogList';
import WorkLogStats from './WorkLogStats';
import { fetchJson } from '@utils/fetchJson';
import { API_BASE_URL } from '../../../config';

const WorkLogShort = ({ record_id = null, taskDetails = null, showEstimate = true }) => {
  const [taskId, setTaskId] = useState(record_id);
  const [estimate, setEstimate] = useState(null);
  const [logs, setLogs] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(false);

  const loadLogsAndEstimate = async (taskID) => {
    if (!taskID) return;
    setLoading(true);
    try {
      const res = await fetchJson(`${API_BASE_URL}/taskMaster/timeEstimation`, {
        method: 'POST',
        body: JSON.stringify({ taskID, type: 'GET' }),
      });
      setEstimate(res.estimate || null);
      setLogs(res.data || []);
    setLoading(false);
    } catch (err) {
      console.error('Failed to fetch work log info', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (taskId) {
      loadLogsAndEstimate(taskId);
    }
  }, [taskId]);

  const handleLogSaved = () => {
    if (taskId) loadLogsAndEstimate(taskId);
    setShowForm(false);
  };

  return (
    <div className="bg-white">
      {!taskId && (
        <div className="mb-4">
          <SmartSelectInput
            id="task_selector"
            value={null}
            onSelect={(val) => setTaskId(val.value)}
            config={{
              type: 'task',
              source: 'taskList',
              placeholder: 'Select a task',
              preload: true,
            }}
          />
        </div>
      )}

      {taskId && (
        <div className="flex justify-between items-center mb-4">
          {showEstimate && <WorkLogStats estimate={estimate} logs={logs} />}
          <button
            className="bg-blue-600 text-white px-4 py-1 text-sm rounded"
            onClick={() => setShowForm(true)}
          >
            + Add Work Log
          </button>
        </div>
      )}
        {showForm && (
        <WorkLogForm
          taskId={taskId}
          onClose={() => setShowForm(false)}
          onSaved={handleLogSaved}
        />
      )}
        {logs.length>0 && (
            <WorkLogList logs={logs} loading={loading} />
        )}
    </div>
  );
};

export default WorkLogShort;
